import { createSelector } from 'reselect'
import { RootState } from '../../reducers'

const getNodeState = (state: RootState) => state.node

export const isFetchingNodes = createSelector(
  getNodeState,
  (node) => node.isFetching
)
export const getNodes = createSelector(getNodeState, (node) => node.nodes)

export const getExtClients = createSelector(
  getNodeState,
  (node) => node.externalClients
)

export const getCurrentQrCode = createSelector(
  getNodeState,
  (node) => node.qrData
)

export const getShouldSignOut = createSelector(
  getNodeState,
  (node) => node.shouldSignOut
)

export const getNodeSort = createSelector(getNodeState, (node) => node.nodeSort)

export const getNodesMap = createSelector(getNodeState, (node) => node.nodesMap)
